import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import Checkbox, { ColorName } from '../Checkbox/ColorCheckbox';
import FilterOverlay from './FilterOverlay';
import FilterHeading from './FilterHeading';
import breakpoints from '../Theme/breakpoints';

const FilterSet = styled.div<{ loadingProp?: boolean }>`
  margin: 0 0 20px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  filter: blur(${({ loadingProp }) => (loadingProp ? '2px' : '0px')});
  label .MuiFormControlLabel-label {
    padding-left: 3px;
  }

  @media (min-width: ${breakpoints.md}px) {
    margin: 0 0 32px;
  }
`;

const CheckboxWrapper = styled.div`
  flex: 1 0 36%;
  padding: 4px 0 0;
  margin: 0 0 -2px 6px;

  @media (min-width: ${breakpoints.md}px) {
    margin: 0 0 -2px 6px;
  }

  &&& {
    .mdc-checkbox__background {
      background-color: transparent;
    }
    .MuiFormControlLabel-label {
      font-size: 0.75rem;
      font-weight: bold;
    }
  }
`;

const ColorCheckbox = styled(Checkbox)`
  margin: 0;
  display: inline-block;
  &:before {
    content: none;
  }
`;

const colorFilterPropertyTypes = {
  title: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      name: PropTypes.string.isRequired,
      onChange: PropTypes.func,
    }).isRequired,
  ).isRequired,
  selected: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ).isRequired,
};

type ColorFilterProperties = Omit<
InferProps<typeof colorFilterPropertyTypes>, 'choices'> & {
  loading?: boolean;
  choices: {
    name: ColorName;
    onChange?: () => void;
    id?: number | string;
  }[];
};

const ColorFilter = ({
  title, choices, selected, loading = false,
}: ColorFilterProperties) => (
  <FilterSet loadingProp={loading} className="product-filter">
    { loading && <FilterOverlay /> }
    <FilterHeading tag="h2" modal>
      {title}
    </FilterHeading>
    {choices.map((choice) => (
      <CheckboxWrapper key={choice.id}>
        <ColorCheckbox
          name={choice.name}
          checked={selected.includes(choice.id)}
          onChange={choice.onChange}
        />
      </CheckboxWrapper>
    ))}
  </FilterSet>
);

ColorFilter.propTypes = colorFilterPropertyTypes;

export default ColorFilter;
